import type { MessageListItem as MessageListItemType } from '@/types/message';
import { formatRelativeTime } from '@/utils/formatRelativeTime';
import { truncateText } from '@/utils/truncateText';

interface MessageListItemProps {
  message: MessageListItemType;
  onClick: () => void;
}

export default function MessageListItem({ message, onClick }: MessageListItemProps) {
  const isUnread = !message.is_read && message.initiated_by === 'agent';

  return (
    <button
      onClick={onClick}
      className={`
        w-full border-b border-neutral-300 px-4 py-3 text-left transition-colors hover:bg-neutral-300
        ${isUnread ? 'bg-primary-50/30' : ''}
      `}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            {/* Agent/User indicator */}
            {message.initiated_by === 'agent' && (
              <span className="flex-shrink-0 text-primary-500" title="Agent-initiated">
                <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6z" />
                </svg>
              </span>
            )}
            <h3
              className={`truncate text-sm ${
                isUnread ? 'font-semibold text-neutral-900' : 'font-medium text-neutral-700'
              }`}
            >
              {message.title}
            </h3>
          </div>
          <p className="mt-0.5 truncate text-xs text-neutral-500">
            {truncateText(message.preview, 80)}
          </p>
        </div>
        <div className="flex flex-shrink-0 flex-col items-end gap-1">
          <span className="text-xs text-neutral-500">
            {formatRelativeTime(message.updated_at)}
          </span>
          {isUnread && (
            <span className="h-2 w-2 rounded-full bg-primary-600" />
          )}
        </div>
      </div>
    </button>
  );
}
